import React from 'react'
import { MDBDataTable } from 'mdbreact'

export default props => (
  <MDBDataTable
    responsive
    striped
    bordered
    entriesLabel=""
    infoLabel={['Mostrando', 'à', 'de', 'registros.']}
    paginationLabel={['Anterior', 'Próxima']}
    searchLabel="Buscar"
    noRecordsFoundLabel="Nenhum registro encontrado."
    {...props}
  />
)
